import { css } from "styled-components";

export const inactiveCandidateCardCss = css<{ inactive?: string }>`
  ${({ inactive }) => {
    if (inactive) {
      return `
      background-color: #d6d6d6;
      &:hover {
        background-color: #cfcfcf;
      }
      `;
    }
  }}
`;
